import React from 'react';
import { 
  FiSearch, FiUser, FiHeart, FiShoppingCart, 
  FiPhone, FiMail, FiChevronDown, FiArrowRight, 
  FiArrowLeft, FiEye, FiEyeOff, FiTruck, FiHeadphones, 
  FiLock, FiRotateCcw, FiMenu, FiX, FiShoppingBag,
  FiChevronUp, FiLink
} from 'react-icons/fi';
import { 
  FaStar, FaPlay, FaFacebookF, FaTwitter, 
  FaPinterestP, FaInstagram, FaHeart as FaHeartFilled 
} from 'react-icons/fa';

const SVGIcon = ({ name, className = '', size = 20, fill = 'none', stroke = 'currentColor' }) => {
  // Map our icon name to React Icons
  const icons = {
    search: <FiSearch size={size} />,
    user: <FiUser size={size} />,
    heart: fill === 'none' || fill === 'currentColor' ? <FiHeart size={size} /> : <FaHeartFilled size={size} color={fill} />,
    cart: <FiShoppingCart size={size} />,
    bag: <FiShoppingBag size={size} />,
    phone: <FiPhone size={size} />,
    mail: <FiMail size={size} />,
    chevronDown: <FiChevronDown size={size} />,
    chevronUp: <FiChevronUp size={size} />,
    arrowRight: <FiArrowRight size={size} />,
    arrowLeft: <FiArrowLeft size={size} />,
    star: fill === 'none' || fill === '#CCCCCC' ? <FaStar size={size} color="#CCCCCC" /> : <FaStar size={size} color={fill} />,
    play: <FaPlay size={size} />,
    facebook: <FaFacebookF size={size} />,
    twitter: <FaTwitter size={size} />,
    pinterest: <FaPinterestP size={size} />,
    instagram: <FaInstagram size={size} />,
    link: <FiLink size={size} />,
    eye: <FiEye size={size} />,
    eyeOff: <FiEyeOff size={size} />,
    shipping: <FiTruck size={size} />,
    support: <FiHeadphones size={size} />,
    secure: <FiLock size={size} />,
    guarantee: <FiRotateCcw size={size} />,
    menu: <FiMenu size={size} />,
    close: <FiX size={size} />
  };

  return icons[name] ? <span className={`svg-icon-wrap ${className}`}>{icons[name]}</span> : null;
};

export default SVGIcon;
